import { HTTP_STATUS, SearchFastighetResult, SearchResultBeteckning } from 'models';

import { LMApi } from 'api/LMApi';

type ExtendedSearchResultBeteckning = {
  http_status_code: HTTP_STATUS | undefined;
  searchResultBeteckning: SearchResultBeteckning;
};

type LMSearchFastighetsbeteckningParams = {
  beteckning: string;
  maxhits?: number;
  status?: string;
  objektstatus?: string;
};

export const LMSearchFastighetSlice = LMApi.injectEndpoints({
  endpoints: (build) => ({
    searchLmFastighetsbeteckning: build.query<ExtendedSearchResultBeteckning, LMSearchFastighetsbeteckningParams>({
      transformResponse: (response: SearchResultBeteckning, meta) => {
        return {
          http_status_code: meta?.response?.status,
          searchResultBeteckning: response
        };
      },
      query: (params) => {
        const cleanedParams = Object.fromEntries(
          Object.entries(params)
            .filter(([, value]) => value !== undefined && value !== null)
            .map(([key, value]) => [key, String(value)])
        );
        const searchParams = new URLSearchParams(cleanedParams).toString();

        return `/search/beteckning?${searchParams}`;
      }
    }),
    searchLmFastighet: build.query<SearchFastighetResult, string | undefined>({
      transformErrorResponse(baseQueryReturnValue) {
        return {
          ignoreHttpError: [HTTP_STATUS.BAD_REQUEST, HTTP_STATUS.INTERNAL_SERVER_ERROR],
          ...baseQueryReturnValue
        };
      },
      query: (beteckning) => {
        return `/search/beteckning/referens?beteckning=${beteckning}`;
      }
    })
  })
});

export const { useLazySearchLmFastighetsbeteckningQuery, useSearchLmFastighetQuery } = LMSearchFastighetSlice;
